import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AlertWarningComponent } from './alert-warning.component';

@NgModule({
  declarations: [AlertWarningComponent],
  imports: [CommonModule],
  exports: [AlertWarningComponent]
})
export class AlertWarningModule {}
